<template>
    <x-ajax-dropdown
        :url="`/api/devotion-categories`"
        @input="handleInput"
        :value="selectedResource"
        :placeholder="placeholder"
        :query="query"
        :blacklist="blacklist"
        :disabled="isLoading"
        label="label"
        trackBy="id"
        :allowEmpty="true"
    />
</template>

<script>
import axios from "axios";
import { get } from "lodash";
import { emptyPromise, handleGeneralXhrError } from "../helpers";
import XAjaxDropdown from "./XAjaxDropdown.vue";

export default {
    components: { XAjaxDropdown },
    created() {
        this.initSelectedResource();
    },
    data() {
        return {
            isLoading: false,
            selectedResource: null,
        };
    },
    methods: {
        fetchSelectedResource() {
            if (this.valueIsEmpty()) {
                this.selectedResource = null;
                return emptyPromise();
            }
            this.isLoading = true;
            const request = axios
                .get(`/api/devotion-categories/${this.value}`)
                .then((response) => {
                    this.selectedResource = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleInput(category) {
            this.selectedResource = category;
            if (this.valueIsEmpty()) {
                this.$emit("input", this.defaultParser(category));
                return;
            }
            this.$emit(
                "input",
                this.valueIsObject() ? category : get(category, "id", null)
            );
        },
        initSelectedResource() {
            if (!this.valueIsEmpty() && !this.valueIsObject()) {
                this.fetchSelectedResource();
                return;
            }
            this.selectedResource = this.value;
        },
        valueIsEmpty() {
            return this.value === null;
        },
        valueIsObject() {
            return typeof this.value === "object";
        },
    },
    props: {
        blacklist: {
            type: Array,
            required: false,
            default: () => [],
        },
        defaultParser: {
            type: Function,
            required: false,
            default: (data) => data.id,
        },
        placeholder: {
            type: String,
            required: false,
            default: "Pilih Kategori",
        },
        query: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        value: {
            type: [Number, Object],
            required: false,
            default: null,
        },
    },
    watch: {
        value: {
            handler() {
                this.initSelectedResource();
            },
            deep: true,
        },
    },
};
</script>
